import { Middleware } from "@reduxjs/toolkit";
import { loginSuccess, logout, userSuccess } from "src/store/auth/authSlice";
import { queryClient } from "src/queryClient";

export const authMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);

  if (loginSuccess.match(action) || userSuccess.match(action)) {
    const authState = store.getState().auth;
    localStorage.setItem('authState', JSON.stringify(authState));
  }

  if (loginSuccess.match(action) || logout.match(action)) {
    queryClient.clear();
  }

  if (logout.match(action)) {
    localStorage.removeItem('authState');
  }

  return result;
};
